// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2xpVJ","button":"styles_button__12MRT","content":"styles_content__3vOvA"};